<template>
  <div>
    <el-card>
      <h3 class="title">连接方式</h3>
      <el-form label-position="left" ref="ruleForm" :rules="rules" :model="connectData" :disabled="disabledFlag">
        <el-form-item prop="overTime" label-width="120px">
          <el-row slot="label">
            <span class="name">超时时间</span>
            <el-tooltip content="添加设备等待时间，单位为(秒)S" placement="top" effect="light">
              <span class="el-icon-question" style="margin-left: 10px"></span>
            </el-tooltip>
          </el-row>
          <el-col :span="12">
            <el-input v-model.trim="connectData.overTime" @input="overTimeInput" placeholder="请输入整数，限制三位，单位为秒"
              :maxlength="3" />
          </el-col>
        </el-form-item>
        <el-form-item label="按钮文字" label-width="120px" prop="button">
          <el-col :span="8">
            <!-- <el-input v-model="connectData.button" placeholder="文字最好控制在8个字内"/> -->
            <el-select v-model="connectData.button" placeholder="请选择按钮文字">
              <el-option v-for="item in btnTextList" :key="item.id" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="倒计时动画" label-width="120px">
          <el-col :span="12">
            <el-select v-model="connectData.countdownType" placeholder="请选择产品品类" style="width: 100%;">
              <el-option v-for="item in countdownType" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-col>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>

export default {
  props: {
    connectData: {
      type: Object
    },
    disabledFlag: {
      type: Boolean
    }
  },
  data() {
    const overTimeVerify = (rule, value, callback) => {
      console.log(value)
      if (value) {
        const reg = /^[0-9]\d*$/ // 匹配正整数
        reg.test(value) ? callback() : callback(new Error('请输入整数且不包括负数'))
      } else {
        callback(new Error('请输入超时时间'))
      }
    }
    return {
      btnTextList: [
        {
          id: 0,
          name: '下一步',
          value: '下一步'
        },
        {
          id: 1,
          name: 'next',
          value: 'next'
        }
      ],
      rules: {
        overTime: [
          { required: true, validator: overTimeVerify, trigger: 'blur' }
        ],
        button: [
          { required: true, message: '请选择按钮文字', trigger: 'change' }
        ]
      },
      countdownType: [
        {
          label: '百分比动画',
          value: 0
        },
        {
          label: '倒计时动画',
          value: 1
        }
      ]
    }
  },
  created() {
  },
  methods: {
    overTimeInput(e) {
      let num = Number(e.replace(/\D/g, ""));
      if (num === 0) {
        this.connectData.overTime = ''
      } else {
        this.connectData.overTime = num;
      }
    }
  }
}
</script>

<style lang='less' scoped>
.el-card {
  padding: 14px;
}

/deep/ .el-card__body {
  padding: 0;
}

.title {
  width: 10%;
  padding: 5px 5px 5px 0;
  display: inline-block;
  margin-bottom: 10px;
  border-bottom: 1px solid #e6e2e2;
}

/deep/ .el-form-item__label {
  display: flex;
}
</style>
